$ = require 'jquery'
Backbone = require 'backbone'
ClientConfig = require 'debug/client-config'
Controller = require 'controller'
Dates = require 'lib/dates'
Monitor = require 'lib/monitor'
SessionStatus = require 'network/session-status'
PopOver = require 'views/lib/pop-over'
trackQuickloadEvent = require 'debug/trackQuickloadEvent'
Util = require 'lib/util'
WindowSize = require 'lib/window-size'
templates = require 'views/internal/templates'
logError = require 'debug/log-error'
require 'debug/client-version-header'

# Extend jQuery with the format and formatHtml methods
require 'lib/jquery-localize'

$ ->
  setInterval ->
    Dates.update('body')
    Dates.trigger('renderInterval')
    return
  , 10 * 1000

  SessionStatus.start()
  Monitor.init()
  Controller.start().then ->
    Backbone.history.start({ pushState: true })
  WindowSize.ensureRun()

  QuickLoad.onRemove (preloadObj) ->
    if !preloadObj.used
      trackQuickloadEvent 'quickload unused', preloadObj.url



// WEBPACK FOOTER //
// ./app/scripts/entry/trellis-client.coffee